import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  query OptimizelyUserQuery {\n    user {\n      uuid\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { OptimizelyProvider } from '@optimizely/react-sdk';
import gql from 'graphql-tag';
import React from 'react';
import { useQuery } from 'react-apollo';
var QUERY = gql(_templateObject());

var Provider = function Provider(props) {
  var _data$user, _data$user2;

  var _useQuery = useQuery(QUERY),
      data = _useQuery.data;

  var uuid = (data === null || data === void 0 ? void 0 : (_data$user = data.user) === null || _data$user === void 0 ? void 0 : _data$user.uuid) || window.mobileUuid;
  var attributes = {
    uuid: (data === null || data === void 0 ? void 0 : (_data$user2 = data.user) === null || _data$user2 === void 0 ? void 0 : _data$user2.uuid) || window.mobileUuid
  };
  return /*#__PURE__*/React.createElement(OptimizelyProvider, {
    optimizely: props.optimizely,
    user: {
      attributes: attributes,
      id: uuid
    }
  }, props.children);
};

export default Provider;